import { __decorate } from "tslib";
import React from 'react';
import moment from 'moment';
import noop from 'lodash/noop';
import classNames from 'classnames';
import DaysView, { alwaysValidDate } from './DaysView';
import TimesView from './TimesView';
import autobind from '../_util/autobind';
import { ViewMode } from './enum';
import { FieldType } from '../data-set/enum';
import { $l } from '../locale-context';
import { getDateFormatByFieldType } from '../field/utils';
export default class DateTimesView extends DaysView {
    constructor() {
        super(...arguments);
        this.getTimeProps = () => {
            const { format = getDateFormatByFieldType(TimesView.type) } = this.props;
            const timeProps = {
                ...this.props,
                mode: ViewMode.time,
                datetimeSide: true,
                format,
                renderExtraFooter: undefined,
            };
            return timeProps;
        };
    }
    getViewClassName() {
        const { prefixCls } = this;
        return `${prefixCls}-datetime`;
    }
    handleTimeSelect() {
        this.changeViewMode(ViewMode.time);
    }
    handleCellClick(date) {
        this.changeSelectedDate(date);
    }
    handleKeyDownRight(e) {
        if (e.altKey) {
            this.changeViewMode(ViewMode.time);
        }
        else {
            this.changeCursorDate(this.getCloneDate().add(1, 'd'));
        }
    }
    getFirstDay(date) {
        const firstDay = date.clone().subtract(1, 'M');
        const hour = firstDay.hour();
        const minute = firstDay.minute();
        const second = firstDay.second();
        firstDay.date(firstDay.daysInMonth()).startOf('w');
        firstDay.hour(hour);
        firstDay.minute(minute);
        firstDay.second(second);
        return firstDay;
    }
    choose(date, expand = true) {
        const { onSelect = noop, date: selectedDate, isValidDate = alwaysValidDate } = this.props;
        const selected = selectedDate.clone();
        if (isValidDate(date, selected) && isValidDate(date, selected, ViewMode.time)) {
            onSelect(date, expand);
        }
    }
    renderFooter() {
        const { prefixCls, props: { disabledNow, okButton }, } = this;
        const footerProps = {
            className: classNames(`${prefixCls}-footer-now-btn`, {
                [`${prefixCls}-now-disabled`]: disabledNow,
            }),
            onClick: !disabledNow ? this.choose.bind(this, moment(), false) : noop,
        };
        return (React.createElement("div", { className: `${prefixCls}-footer` },
            React.createElement("a", Object.assign({}, footerProps), $l('DatePicker', 'now')),
            okButton && (React.createElement("a", { className: `${prefixCls}-footer-view-select`, onClick: this.choose.bind(this, this.props.date, false) }, $l('DatePicker', 'ok')))));
    }
    render() {
        const { prefixCls, props: { className, extraFooterPlacement }, } = this;
        const classString = classNames(`${prefixCls}-view`, className, this.getViewClassName());
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${this.getViewClassName()}-wrapper` },
                React.createElement("div", { className: classString },
                    this.renderHeader(),
                    this.renderBody()),
                React.createElement(TimesView, Object.assign({}, this.getTimeProps()))),
            extraFooterPlacement === 'top' && this.customFooter,
            this.renderFooter(),
            extraFooterPlacement === 'bottom' && this.customFooter));
    }
}
DateTimesView.displayName = 'DateTimesView';
DateTimesView.type = FieldType.dateTime;
__decorate([
    autobind
], DateTimesView.prototype, "handleTimeSelect", null);
